<template>
  <header>
    <div class="logo">
      <img :src="logoPath" alt="Logo" width="277" height="40" />
    </div>
  </header>
</template>

<script>
export default {
  props: {
    logoPath: {
      type: String,
      required: true,
    },
  },
};
</script>

<style scoped>
.logo {
  margin-left: 16%;
  margin-top: 10px;
}
</style>
